<template>
  <div id="app">
    <Navbar 
      :navLinks="navLinks"
      :navLogo="require('./assets/logo.png')"
      :navMenuIcon="require('./assets/burger_menu_icon.png')"
    />
    <router-view/>
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import Footer from '@/components/Footer'
export default {
  components: {
    Navbar,
    Footer
  },
  data: () => ({
    navLinks: [
      {
        text: 'Home',
        path: '/'
      },
      {
        text: 'Vision',
        path: '/vision'
      }
    ]
  })
}
</script>

<style lang="scss">
body {
    margin: 0;
    padding: 0;
    background-color: #e1e8f0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue